import { auth } from "../config/firebase";

export const debugAuth = {
  // Log current user details
  logCurrentUser() {
    // const user = auth.currentUser;
    // console.log("=== AUTH DEBUG ===");
    // console.log("User:", user);
    // console.log("Email:", user?.email);
    // console.log("UID:", user?.uid);
    // console.log("Email Verified:", user?.emailVerified);
    // console.log("Token:", user?.accessToken);
    // console.log("==================");
  },

  // Get and log the current user's ID token
  async logIdToken() {
    try {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        // console.log("=== ID TOKEN DEBUG ===");
        // console.log("Token:", token);

        // Decode the token (basic decoding for debugging)
        const payload = JSON.parse(atob(token.split(".")[1]));
        // console.log("Token Payload:", payload);
        // console.log("Email in token:", payload.email);
        // console.log("======================");
      }
    } catch (error) {
      console.error("Error getting ID token:", error);
    }
  },

  // Test Firebase connection
  async testFirebaseConnection() {
    try {
      // console.log("=== FIREBASE CONNECTION TEST ===");
      // console.log("Auth instance:", auth);
      // console.log("Current user:", auth.currentUser);
      // console.log("App name:", auth.app.name);
      // console.log("Project ID:", auth.app.options.projectId);
      // console.log("================================");
    } catch (error) {
      console.error("Firebase connection error:", error);
    }
  },
};
